"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DummyErrorReporting {
    sendFatalError(_message, ..._details) {
        // NOP
    }
    sendNonFatalError(_message, ..._details) {
        // NOP
    }
    sendFatalException(_err, ..._details) {
        // NOP
    }
    sendNonFatalException(_err, ..._details) {
        // NOP
    }
}
exports.DummyErrorReporting = DummyErrorReporting;
//# sourceMappingURL=dummy-error-reporting.js.map